const FETCH_TIMEOUT_MS = 9000
const FETCH_RETRIES = 2

/**
 * Fetch with timeout
 */
export async function fetchWithTimeout(
  url: string,
  options: RequestInit = {},
  timeoutMs: number = FETCH_TIMEOUT_MS
): Promise<Response> {
  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeoutMs)
  try {
    return await fetch(url, { ...options, signal: controller.signal })
  } finally {
    clearTimeout(id)
  }
}

/**
 * Fetch JSON with retry logic
 */
export async function fetchJsonRobust(
  url: string,
  options: RequestInit = {},
  config: { timeoutMs?: number; retries?: number } = {}
): Promise<any> {
  const { timeoutMs = FETCH_TIMEOUT_MS, retries = FETCH_RETRIES } = config
  let lastErr: Error | null = null

  for (let i = 0; i <= retries; i++) {
    try {
      const res = await fetchWithTimeout(url, options, timeoutMs)
      if (!res.ok) {
        const txt = await res.text().catch(() => '')
        throw new Error(`${res.status} ${txt.slice(0, 160)}`)
      }
      return await res.json()
    } catch (e) {
      lastErr = e instanceof Error ? e : new Error(String(e))
      if (i < retries) {
        await new Promise((r) => setTimeout(r, 220 * (i + 1)))
      }
    }
  }

  throw lastErr || new Error('Fetch failed')
}
